import { render } from "./TransactionLoader.vue?vue&type=template&id=fc32f8de&scoped=true"
import script from "./TransactionLoader.vue?vue&type=script&lang=js"
export * from "./TransactionLoader.vue?vue&type=script&lang=js"

import "./TransactionLoader.vue?vue&type=style&index=0&id=fc32f8de&scoped=true&lang=css"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc32f8de"]])

export default __exports__